<div class="moment-by-type-autocomplete">
	<!-- moment type -->
	<!-- <portals-multiselect-autocomplete
		class="filter"
		[placeholder]="'AI Type'"
		[fieldLabel]="'AI Type'"
		[selectedData]="selectedTypes"
		[entityName]="'moment'"
		[fieldName]="'type'"
		(onValueChange)="onChangeTypeFieldValue($event)"
	></portals-multiselect-autocomplete> -->
	<!-- moment name -->
	<portals-multiselect-autocomplete class="filter" [placeholder]="'Words'" [fieldLabel]="'Words'" [selectedData]="selectedNames" [entityName]="entityName" [fieldName]="'name'" [filterParams]="filterParam" (onValueChange)="onChangeNameFieldValue($event)"></portals-multiselect-autocomplete>
</div>
